export const NotificationsEndpoints = {
  root: 'notifications',
  customerRoot: '/client/notifications',
  storeRoot: '/store/notifications',
}
